import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CountryQueryObject {
  country: {
    __args: {
      id: string
    }
    id: true
    two_letter_abbreviation: boolean
    three_letter_abbreviation: boolean
    full_name_locale: boolean
    full_name_english: boolean
    available_regions: {
      id: boolean
      code: boolean
      name: boolean
    }
  }
}

export const countryQueryObject: CountryQueryObject = {
  country: {
    __args: {
      id: ''
    },
    id: true,
    two_letter_abbreviation: true,
    three_letter_abbreviation: true,
    full_name_locale: true,
    full_name_english: true,
    available_regions: {
      id: true,
      code: true,
      name: true
    }
  }
}

interface CountryQueryInput {
  countryCode: string
}

export type CountryQuery = (input: CountryQueryInput) => Promise<ApolloQueryResult<any>>

export const createCountryQuery = ({ getQueries }: ServiceDependencies): CountryQuery => async ({ countryCode }) => {
  const query = getQueries().countryQuery
  query.country.__args.id = countryCode

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`
  })
}
